module.exports = __webpack_public_path__ + "static/img/gouwuche.970dd43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gouwuche.png
// module id = iAPV
// module chunks = 52